import React, { forwardRef } from "react"
import PropTypes from "prop-types"
import { Select } from "./styles"

const SelectField = forwardRef(({ handleInputChange, options, blank, ...rest }, ref) => {
  const onChange = (event) => {
    const { name, value } = event.target
    if (handleInputChange !== undefined) handleInputChange(name, value)
  }

  return (
    <Select onChange={onChange} numberOfOptions={options?.length || 0} ref={ref} {...rest}>
      {blank && <option value="">{blank}</option>}
      {options.map((option, index) => (
        <option key={option[0] + index} value={option[0]}>
          {option[1]}
        </option>
      ))}
    </Select>
  )
})

SelectField.propTypes = {
  handleInputChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  blank: PropTypes.string,
  showValidation: PropTypes.bool.isRequired,
  invalid: PropTypes.bool
}

SelectField.defaultProps = {
  handleInputChange: undefined,
  options: [],
  showValidation: false,
  blank: "Please select",
  invalid: false
}

export default SelectField
